import React, {useContext} from 'react'
import {Form, Input} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";


const HeaderUrlPath = () => {
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handlePathChange = (event) => {
        let mockResponse = Object.assign({}, recipeById)
        mockResponse.recipe.imageUrl = event.target.value
        setRecipeById(mockResponse)
    }

    return(
        <React.Fragment>
            <Form.Item
                initialValue={recipeById.recipe.imageUrl}
                onChange={handlePathChange}
                className={'font-bold'}
                name={'pathInput'}
                label={'Dosya yolu'}>
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default HeaderUrlPath